import { gql } from 'graphql-request'

export const GET_CAMPAIGN_DETAIL = gql`
  query CampaignDetail($id: Int!) {
    campaign(id: $id) {
      id
      name
      type
      status
      wholeStoryDiscountType
      freeReadingType
      bookCount
      startDate
      endDate
      createdAt
      updatedAt
      items {
        id
        bookId
        bookTitle
        bookPenFirstName
        bookPublisherName
        chapterIdStart
        chapterIdEnd
        discountPricePerChapter
        discountPercentage
        discountCoin
        originalPrice
        discountedPrice
        dailyChapters
        freeDays
        startDate
        endDate
      }
    }
  }
`
